import React, { Fragment } from "react";
import { Button, UncontrolledTooltip } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons';
import { Link } from "react-router-dom";
import { ACL } from '../../../../../../../config/constants/UogACL/ACL';

function RemoveUserFromGroup(props) {
  const {index, user, showIcon, removeUser} = props;

  if (! ACL.ADMIN.GROUPS.SYNC_USERS.hasAccess()) {
    return null;
  }

  return (<Fragment>
      {!showIcon ?
        <Fragment>
          <Button
            color="primary"
            size="sm"
            className="btn-warning"
            type="button"
            id={`remove-user-${index}`}
            onClick={e => {
              e.preventDefault();
              removeUser(user);
            }}
          >
            <FormattedMessage
              id="components.pages.admin.tabs.users_in_group_table.actionButtons.remove_user"/>
          </Button>
          <UncontrolledTooltip
            delay={0}
            target={`remove-user-${index}`}
            modifiers={{
              preventOverflow: {
                enabled: true,
                boundariesElement: "body",
              },
            }}
          >
            <FormattedMessage
              id="components.pages.admin.tabs.users_in_group_table.actionButtons.remove_user"/>
          </UncontrolledTooltip>
        </Fragment> :
        <Fragment>
          <Link
            to="#"
            className="cursor-pointer px-2 mx-2 link-icon-color"
            id={`remove-user-` + index}
            onClick={e => {
              e.preventDefault();
              removeUser(user);
            }}
          >
            <FontAwesomeIcon
              size="lg"
              className="align-middle cursor-pointer"
              pointerEvents="none"
              icon={faMinusCircle}
            />
          </Link>
          <UncontrolledTooltip
            delay={0}
            target={`remove-user-${props.index}`}
            modifiers={
              {
                preventOverflow: {
                  enabled: true,
                  boundariesElement: 'body'
                }
              }
            }
          >
            <FormattedMessage
              id="components.pages.admin.tabs.users_in_group_table.actionButtons.remove_user"/>
          </UncontrolledTooltip>
        </Fragment>
      }
    </Fragment>
  );
}

export { RemoveUserFromGroup };
